import { Route, Routes } from "react-router";
import React from "react";

import Dashboard from "./components/Dashboard";
import DashboardAdmin from "./components/DashboardAdmin";
import Login from "./components/Login";
import User from './components/User';
import Trash from './components/DashboardTrash';
import TrashAdmin from './components/DashboardTrashAdmin';
import Folder from './components/DashboardFolder';
import Password from './components/PasswordChange';
import Administrador from "./components/Administrador";
import ProtectedRouteAdmin from "./security/ProtectedRouteAdmin";
import ProtectedRoute from "./security/ProtectedRoute";
import RedirectLogin from "./components/RedirectLogin";

import ResetPasswordRedirect from './components/ResetPasswordRedirect';
import PasswordChange from './components/PasswordChange';

const AdminProtectedRoute = () => <ProtectedRouteAdmin requiredRole="ROLE_ADMIN" />;

const Router = () => {
  return (
  <Routes>

  {/* EMAIL */}
  <Route path="/reset-password" element={<ResetPasswordRedirect />} />

  {/* PANTALLA FINAL */}
<Route path="/PasswordChange" element={<PasswordChange />} />

  <Route path='/' element={<Login />} />
  <Route path="/redirect" element={<RedirectLogin />} />

  <Route element={<ProtectedRoute />}>
    <Route path='dashboard' element={<Dashboard />} />
    <Route path='dashboardtrash' element={<Trash />} />
    <Route path="/dashboardfolder/:folderId" element={<Folder />} />
    <Route path='user' element={<User />} />
    <Route path='passwordchange' element={<Password />} />
  </Route>

  <Route element={<AdminProtectedRoute />}>
    <Route path='dashboardAdmin' element={<DashboardAdmin />} />
    <Route path='admin' element={<Administrador />} />
    <Route path='dashboardtrashAdmin' element={<TrashAdmin />} />
  </Route>

</Routes>
  );
};

export default Router;
